import {Component, EventEmitter, Input, OnInit, Output} from "@angular/core";
import {Product} from "../product";
import {Website} from "../website";
import {IDropdownListItem} from "../../../shared/components/dropdown-list/dropdown-list-item";
import {UserSubscription, UserSubscriptionCategory} from "../../../user/user-subscription";
import {DbStoreState} from "../../../store/reducers";
import {Store} from "@ngrx/store";
import * as fromStore from '../../../store';
import {ActivityAction, ActivityStatus, IActivity} from "../../../activities/activity";
import {Observable} from "rxjs";
import {Router} from "@angular/router";
import {MultisiteActionConfirmDialogComponent} from "../../../shared/components/dialogs/mulitiste-action-confirm-dialog/multisite-action-confirm-dialog.component";
import {TextUtils} from "../../../shared/utils/text-utils";
import {DialogService} from "../../../../ng2-bootstrap-modal/dialog.service";

@Component({
    selector: 'db-extension-item',
    templateUrl: './extension-item.component.html',
    styleUrls: ['./extension-item.component.scss'],
    standalone: false
})
export class ExtensionItemComponent implements OnInit {

  public ActivityAction = ActivityAction;
  public ActivityStatus = ActivityStatus;

  @Input() website: Website;
  @Input() product: Product;
  @Input() parentProduct: Product;
  @Input() scope: string;
  @Input() isManagable: boolean;

  @Output() toggled: EventEmitter<void>;
  @Input() userSubscriptions: UserSubscription[];
  @Input() currentSubscription: UserSubscription;

  public items: IDropdownListItem[];
  public InactiveItems: IDropdownListItem[];
  public UpdateItems: IDropdownListItem[];
  public ActiveItems: IDropdownListItem[];
  public productDesc: string;

  public ongoingActivity$: Observable<IActivity>;

  constructor(
    private _store: Store<DbStoreState>,
    private _dialogService: DialogService,
    private _router: Router
  ) {
    this.toggled = new EventEmitter<void>();

    this.items = [
      {
        label: TextUtils.getText('text_delete'),
        icon: 'plugins',
        action: () => {
          this.delete();
        }
      }
    ];


    this.InactiveItems = [
      {
        label: TextUtils.getText('text_activate'),
        icon: 'plugins',
        action: () => {
          this.activate();
        }
      },
      {
        label: TextUtils.getText('text_delete'),
        icon: 'plugins',
        action: () => {
          this.delete();
        }
      }
    ];

    this.UpdateItems = [
      {
        label: TextUtils.getText('text_update'),
        icon: 'plugins',
        action: () => {
          this.update();
        }
      }
    ];

    this.ActiveItems = [
      {
        label: TextUtils.getText('text_deactivate'),
        icon: 'plugins',
        action: () => {
          this.deactivate();
        }
      },
      {
        label: TextUtils.getText('text_deactivateDelete'),
        icon: 'plugins',
        action: () => {
          this.deactivate();
          this.delete();
        }
      }
    ];

  }

  ngOnInit() {
    if (this.product.description.length > 120) {
      const shortDesc = this.product.description.substr(0, 120);
      this.productDesc = shortDesc.substr(0, Math.min(shortDesc.length, shortDesc.lastIndexOf(" "))) + '...';
    }
    else {
      this.productDesc = this.product.description;
    }

    this.ongoingActivity$ = this._store.select(fromStore.getProductOngoingActivity(this.website.id, this.product.slug));
  }

  public install(): void {
    let network = 0;
    if (this.website.isNetwork) {
      network = 1;
    }
    this.dispatchActions(network, ActivityAction.INSTALL);
  }

  public installAndActivate(): void {
    const network = 0;
    if (this.website.isNetwork) {
      this.openConfirmationDialog(network, ActivityAction.INSTALL_ACTIVATE);
    }
    else {
      this.dispatchActions(network, ActivityAction.INSTALL_ACTIVATE);
    }
  }

  public activate(): void {
    const network = 0;
    if (this.website.isNetwork) {
      if (this.website.isNetwork) {
        this.openConfirmationDialog(network, ActivityAction.ACTIVATE);
      }
    }
    else {
      this.dispatchActions(network, ActivityAction.ACTIVATE);
    }
  }

  public deactivate(): void {
    const network = 0;
    if (this.website.isNetwork) {
      this.openConfirmationDialog(network, ActivityAction.DEACTIVATE);
    }
    else {
      this.dispatchActions(network, ActivityAction.DEACTIVATE);
    }

  }

  public update(): void {
    this.dispatchActions(0, ActivityAction.UPDATE);
  }

  public delete(): void {
    this.dispatchActions(0, ActivityAction.DEACTIVATE_DELETE);
  }


  private dispatchActions(network, action) {
    this._store.dispatch(new fromStore.InitWebsiteProductAction({
      website: this.website,
      products: [this.product],
      action: action,
      network: network
    }));
  }

  private openConfirmationDialog(network, action) {
    this._dialogService
      .addDialog(MultisiteActionConfirmDialogComponent, {
        header: TextUtils.getText(action === ActivityAction.DEACTIVATE ? 'text_multisiteDeactivate.header' : 'text_multisiteActivate.header'),
        message: TextUtils.getText(action === ActivityAction.DEACTIVATE ? 'text_multisiteDeactivate.message' : 'text_multisiteActivate.message'),
        singleSiteButtonText: TextUtils.getText(action === ActivityAction.DEACTIVATE ? 'text_deactivate' : 'text_activate'),
        multisiteButtonText: TextUtils.getText(action === ActivityAction.DEACTIVATE ? 'text_networkDeactivate' : 'text_networkActivate'),
      })
      .subscribe((confirmed: string|boolean) => {
        if (confirmed) {
          if (confirmed === 'network') {
            network = 1;
          }
          this.dispatchActions(network, action);
        }
      });
  }

  public onItemToggled(): void {
    this.toggled.emit();
  }


  public stopEvent($event): void {
    $event.preventDefault();
    $event.stopPropagation();
  }


  public showPremiumPluginDialog(): void {
    const activeTab = (this.currentSubscription.category === UserSubscriptionCategory.STARTER || this.currentSubscription.category === UserSubscriptionCategory.REGISTERED) ? 'platform' : 'bundle';
    this._router.navigate(['/upgrade-plan'], { queryParams: {plugin_slug: this.product.slug, plugin_title: this.product.title, active_tab: activeTab } });
  }

}
